<template>
    <v-layout>
        <v-flex>
            <v-card>               
                <v-card-text>
                    <v-data-table
                    :headers="headers"
                    :items="charges"
                    :search="search"
                    >
                    <template v-slot:item.activo="{ item }">  
                        <div v-if="item.activo  ">
                            <span class="blue--text">Activo</span>
                            
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>                
                        </div>                  
                    </template>
                    <template v-slot:item.idinstance="{ item }">  
                        <div v-if="item.idinstance==1">
                            <span class="blue--text">B</span>
                            
                        </div>
                        <div v-else>
                            <span class="blue--text">S</span>                
                        </div>                  
                    </template>
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Charges</v-toolbar-title>
                            <v-divider
                                class="mx-4"
                                inset
                                vertical
                            ></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                            <v-spacer></v-spacer> 
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on }">
                                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                                </template>
                                <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col sm="10" md="10" lg="10">
                                                <v-text-field v-model="description" label="Description"></v-text-field>
                                            </v-col>    
                                            <v-col sm="10" md="3" lg="3">
                                                <v-select label="Instance" v-model="instance" :items="instance"></v-select>
                                            </v-col>                                         
                                            <v-col sm="10" md="3" lg="3">
                                                <v-text-field v-model="codigo" label="code"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>    
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                                </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog  v-model="adModal" max-width="290px">
                                <v-card>
                                    <v-card-title class="headline" v-if="adAccion==1">¿Activar Puerto?</v-card-title>
                                    <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Puerto?</v-card-title>
                                    <v-card-text>
                                        Estás a punto de
                                        <span v-if="adAccion==1">Activar</span>
                                        <span v-if="adAccion==2">Desactivar</span>
                                        el item {{ adNombre }}
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                            Cancelar
                                        </v-btn>
                                        <v-btn v-if="adAccion==1" color="orange darken1" text="text" @click="activar">
                                            Aceptar
                                        </v-btn>
                                        <v-btn v-if="adAccion==2" color="orange darken1" text="text" @click="desactivar">
                                            Desactivar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.opciones="{ item }">
                        <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                        >
                        edit
                        </v-icon>
                        <template v-if="item.activo">                         
                            <v-icon
                                small
                                @click="activarDesactivarMostrar(2,item)"
                                >
                                block
                                </v-icon>                               
                        </template>
                        <template v-else>                         
                            <v-icon
                                small
                                @click="activarDesactivarMostrar(1,item)"
                                >
                                check
                                </v-icon>                               
                        </template> 
                    </template>   
                    <template slot="no-data">
                        <v-btn colo="primary" @click="listar">Resetear</v-btn>
                    </template>
                    </v-data-table>
                </v-card-text>
            </v-card>            
        </v-flex>
    </v-layout>
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
            dialog:false,
            adModal:false,
            description:'',
            instance:'',
            codigo:'',
            headers:[
                {text:'Opciones',value:'opciones'},
                {text:'Description',value:'nombre'},
                {text:'Instance (Buy/Sell)',value:'idinstance'},
                {text:'Codigo',value:'codigo'},
                {text:'Activo',value:'activo'}
            ],
            charges:[],
            search:'',
            editedIndex: -1,
            instance:'',
            instance:[
                {text:'B',value:'1'},
                {text:'S',value:'2'}
            ],
            id:'',
            adAccion:0,
            adNombre:'',
            adId:'',
            adAccion:0,
        }
    },
    computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'New Charge' : 'Update Charge'
        },
    },
    created () {              
        this.listar();
    },
    methods:{
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Charges/Listar',configuracion).then(function(response){
              //console.log(response);
              me.charges=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },        
         close () {
            this.dialog = false;            
            this.limpiar();
        },
        limpiar(){
            this.id="";
            this.nombre="";
            this.descripcion="";
            this.idpuerto="";
            this.codigo="";            
            this.editedIndex=-1;
        },
        guardar () {
            /*if(this.validar()){
                return;
            }*/
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            
            if (this.editedIndex > -1) {//codigo para editar            
                let me=this;    
                console.log(me.instance)            
                axios.put('api/Charges/Actualizar',{
                    'idcharge':me.id,
                    'idinstance':me.instance,                                  
                    'nombre':me.description,
                    'codigo':me.codigo
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });  
            }else{//codigo para guardar
                let me=this;
                axios.post('api/Charges/Crear',{
                    'idinstance':me.instance,                                  
                    'nombre':me.description,
                    'codigo':me.codigo
                },configuracion).then(function(response){
                    me.close();
                    me.listar();
                    me.limpiar();
                }).catch(function(error){
                    console.log(error);
                });                
            }            
        },
        editItem (item) {
            this.id=item.idcharge;
            this.instance=item.idinstance;
            this.description=item.nombre;
            this.codigo=item.codigo;                        
            this.editedIndex=1;
            this.dialog = true
        },
        activarDesactivarMostrar(accion,item){
           this.adModal=true;
           this.adNombre=item.nombre;
           this.adId=item.idcharge;
            if(accion==1)
            {
                this.adAccion=1;                
            }
            else if(accion==2){
                this.adAccion=2;
            }
            else{
                this.adModal=false;
            }
        },
        activarDesactivarCerrar(){
            this.adModal=false;
        },
        activar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Charges/Activar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            }); 
        },
        desactivar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Charges/Desactivar/'+this.adId,{},configuracion).then(function(response){
                me.adModal=false;
                me.adAccion=0;
                me.adNombre="";
                me.adId="";
                me.listar();
            }).catch(function(error){
                console.log(error);
            });
        },
        limpiar(){
            this.id = '';
            this.instance.value = '';
            this.description = '';
            this.codigo = '';
            this.editedIndex = -1;
        }
    }
}
</script>